"use strict";

document.addEventListener("DOMContentLoaded", function () {
  var ExternalLinks = function () {
    var $links = $('a').filter(function () {
      if (this.hostname) {
        if (this.hostname !== location.hostname && !this.hostname.includes('myshopify.com')) {
          // console.log(this.hostname);
          return this;
        }
      }
    });
    $links.attr('target', '_blank');
  }();
  var faqPage = function () {
    if ($('body').hasClass('template-page-faqs')) {
      var updateProgress = function updateProgress() {
        var scrollableHeight = $('.faq-wrapper').outerHeight() + $('.faqs-hero').outerHeight();
        if ($('.faq-sticky-main').length) {
          var scrollTop = $(window).scrollTop();
          $faqHeadings.each(function () {
            var elementOffset = $(this).parent().offset().top,
              distance = elementOffset - scrollTop;
            if (scrollTop > lastScrollTop) {
              if (distance > 0 && distance < 250) {
                var tocItem = $(this).parent().attr('id');
                $('.faq-sticky-main a.btn--plain.active').removeClass('active');
                $('.faq-sticky-main a.btn--plain[href="#' + tocItem + '"]').addClass('active');
              }
            } else {
              if (distance < 250 && distance < 500) {
                var tocItem = $(this).parent().attr('id');
                $('.faq-sticky-main a.btn--plain.active').removeClass('active');
                $('.faq-sticky-main a.btn--plain[href="#' + tocItem + '"]').addClass('active');
              }
            }
          });
          lastScrollTop = scrollTop;
        }
      };
      var $faqHeadings = $('.faq-wrapper h2');
      var lastScrollTop = 0;
      $(window).scroll(updateProgress);
      $(window).resize(updateProgress);
      var $faqSearch = $('.faqs-hero input');
      var $questions = $('.faq-item .accordion__label span');
      var $categories = $('.faqs-block');
      $faqSearch.on('keydown', function () {
        var $this = $(this);
        var query = $this.val().toLowerCase();
        $questions.each(function () {
          var $this = $(this);
          var text = $this.text().toLowerCase();
          if (text.indexOf(query) > -1) {
            $this.closest('.faq-item').show();
          } else {
            $this.closest('.faq-item').hide();
          }
        });
        $categories.each(function () {
          var $this = $(this);
          var $items = $this.find('.faq-item:visible');
          if ($items.length) {
            $this.show();
          } else {
            $this.hide();
          }
        });
      });
    }
  }();
  var LazyLoading = function () {
    var instance = new LazyLoad();
    function lazyBGImages() {
      var $bgImages = document.querySelectorAll('[data-bg]:not(.lazy)');
      if ($bgImages.length) {
        $bgImages.each(function () {
          $(this).addClass('lazy');
        });
      }
      instance.update();
    }
    function update() {
      lazyBGImages();
    }
    lazyBGImages();
    function refresh() {
      instance.update();
    }
    return {
      update: update,
      refresh: refresh
    };
  }();
  var StickToHeader = function () {
    function init() {
      var $el = $('.js-header-sticky');
      if (!$el.length) {
        return false;
      }
      $el.each(function () {
        var $this = $(this);
        var header_height = $('.gheader').innerHeight();
        var $this_pos = $this.offset().top;
        $(document).on('scroll', function () {
          header_height = $('.gheader').innerHeight() == header_height ? header_height : $('.gheader').innerHeight();
          $this.toggleClass('is-stuck', window.scrollY + header_height >= $this_pos);
          $this.css('top', header_height).attr('data-header-sticky', $this_pos);
        });
      });
    }
    init();
    return {
      refresh: init
    };
  }();
  var AdjustToHeader = function () {
    var $el = $('.js-adjust-to-header');
    if (!$el.length) {
      return false;
    }
    var wHeight = $(window).height();
    $el.css('max-height', wHeight - $('.gheader').innerHeight());
  }();
  var urlParams = function (strParam) {
    var objParams = {};
    function init() {
      objParams = {};
      var arrURLParams = window.location.search.replace('?', '').split('&');
      arrURLParams.map(function (val) {
        var arrPair = val.split('=');
        objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
      });
    }
    init();
    return {
      get: function get(strParam) {
        return objParams[strParam];
      },
      pull: init
    };
  }();
  var checkForColorURL = function () {
    var color = urlParams.get('select-color');
    if (color) {
      $('#option-color').val(color).trigger('change');
    }
  }();
  var SmoothScroll = function () {
    var $anchorLinks = $('a[href^="#"]').not('a[href="#"]');
    var $jsScrollTo = $('.js-scroll-to');
    $('a[href="#"]').click(function (e) {
      e.preventDefault();
      return;
    });
    function goTo(target) {
      if (target === "" || !$(target).length) {
        return;
      }
      var scrollPos = typeof target === 'number' ? target : $(target).offset().top;
      if (window.innerWidth >= 720) {
        scrollPos -= $('header').outerHeight();
      } else {
        scrollPos -= $('header').outerHeight() * 2;
      }
      if ($('.col-filters').length) {
        scrollPos -= $('.col-filters').outerHeight();
      }
      $('html, body').stop().animate({
        'scrollTop': scrollPos - 32
      }, 1200, 'swing', function () {
        if (typeof target === 'string') {
          if (window.location.hash) {
            // window.location.hash = target;
          }
        }
      });
    }
    if (window.location.hash) {
      setTimeout(function () {
        goTo(window.location.hash);
      }, 500);
    }
    if ($anchorLinks.length) {
      $anchorLinks.on('click', function (e) {
        if (!$("#" + this.hash.replace('#', '')).length) {
          return;
        }
        e.preventDefault();
        var $faqs = $('.faqs-block');
        if ($faqs.length) {
          $faqs.show();
          $('.faq-item').show();
          $('.faqs-hero__search').val('');
        }
        goTo(this.hash);
      });
    }
    if ($jsScrollTo.length) {
      $jsScrollTo.on('click', function (e) {
        e.preventDefault();
        goTo('#' + $(this).data('scrollTo'));
      });
    }
    return {
      to: goTo
    };
  }();
  var Accordions = function () {
    var $accordions = $('.js-dropdown');
    if (!$accordions.length) {
      return;
    }
    $accordions.each(function () {
      $(this).find('.js-dropdown__content').toggle($(this).hasClass('active'));
    });
    $accordions.find('.js-dropdown__trigger').click(function (e) {
      var $this = $(this);
      var $accordion = $this.parent();
      var $content = $accordion.find('.js-dropdown__content');
      var $siblings = $accordion.siblings();
      if ($accordion.hasClass('active')) {
        $accordion.removeClass('active');
        $content.slideUp('fast');
      } else {
        $accordion.addClass('active');
        $siblings.removeClass('active').find('.js-dropdown__content').slideUp('fast');
        $content.slideDown('fast');
      }
    });
  }();

  //Global function top open / close lightboxes
  var PDMLightbox = function () {
    //Lightbox reset - This lightbox is empty and present on all pages
    var $lightbox = $('.pdm-lightbox--reset');

    //it's content can be filled from various sources
    //after close, the content is wiped
    var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');
    $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {
      e.preventDefault();
      var iframe = $(this).data('lightbox-iframe');
      if (iframe) {
        var replacement = '';
        var youtubePattern = /^(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=))([\w-]{11})(?:\S+)?$/g;
        var vimeoPattern = /^(?:https?:\/\/)?(?:www\.)?(?:player\.)?(?:vimeo\.com\/(?:channels\/\w+\/)?|(?:(?:www|player)\.)?vimeo\.com\/(?:showcase\/\w+\/)?video\/)(\d+)(?:\S+)?$/g;
        if (youtubePattern.test(iframe)) {
          classes += ' youtube-vid';
          replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/$1?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';
          iframe = iframe.replace(youtubePattern, replacement);
        }
        if (vimeoPattern.test(iframe)) {
          classes += ' vimeo-vid';
          replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="https://player.vimeo.com/video/$1?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';
          iframe = iframe.replace(vimeoPattern, replacement);
        }
        $lightbox_content.html('<div class="video-embed">' + iframe + '</div>');
      } else {
        var content;
        if ($(this).data('lightbox-content')) {
          content = $(this).data('lightbox-content');
        } else if ($(this).data('lightbox-target')) {
          var target = $(this).data('lightbox-target');
          content = $('#' + target).html();
        } else {
          content = $(this).next('.lightbox-content').html();
        }
        $lightbox_content.html(content);
      }
      var classes = $(this).data('lightbox-classes');
      $lightbox.addClass('active').addClass(classes);
    });
    function closeModal($lightbox) {
      $lightbox.removeClass('active');
      $('body').removeClass('noScroll');
      //wait before removing classes till lightbox closses
      if ($lightbox.hasClass('pdm-lightbox--reset')) {
        setTimeout(function () {
          $lightbox.find('.pdm-lightbox__content').empty();
          $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
        }, 750);
      }
    }
    function openModal($lightbox) {
      $lightbox.addClass('active');
      $('body').addClass('noScroll');
    }
    function updateModal($lightbox, $content) {
      $lightbox.find('.pdm-lightbox__content').html($content);
    }
    $('.pdm-lightbox').on('click', function (e) {
      if (e.target == this) {
        closeModal($(this));
      }
    });
    $('.pdm-lightbox__close').click(function (e) {
      e.stopPropagation();
      closeModal($(this).closest('.pdm-lightbox'));
    });
    return {
      close: closeModal,
      open: openModal,
      update: updateModal
    };
  }();
  var QtyInput = function () {
    function init() {
      var $qtyInputs = $('.js-qty');
      if (!$qtyInputs.length) {
        return;
      }
      var $inputs = $qtyInputs.find('.js-qty__input');
      var $countBtn = $qtyInputs.find('.js-qty__button');
      $inputs.each(function () {
        var min = 1;
        if ($(this).data('min') != undefined) {
          min = parseInt($(this).data('min'));
        }
        if ($(this).val() > min) {
          $(this).siblings('[data-action="subtract"]').attr('disabled', false);
        } else {}
      });
    }
    init();
    $('body').on('change', '.js-qty .js-qty__input', function () {
      var $this = $(this);
      var $minusBtn = $this.siblings('[data-action="subtract"]');
      var qty = parseInt($this.val());
      var min = 1;
      if ($this.data('min') != undefined) {
        min = parseInt($this.data('min'));
      }
      if (isNaN(qty) || qty <= min) {
        $this.val(min);
        $minusBtn.attr('disabled', true);
      } else {
        $minusBtn.attr('disabled', false);
        $this.val(qty);
      }
    });
    $('body').on('click', '.js-qty__button', function () {
      var operator = this.dataset.action;
      var $this = $(this);
      var $input = $this.siblings('.js-qty__input');
      var qty = parseInt($input.val());
      var min = 1;
      if ($input.data('min') != undefined) {
        min = parseInt($input.data('min'));
      }
      if (operator == 'add') {
        qty += 1;
        if (qty == min + 1) {
          $this.siblings('[data-action="subtract"]').attr('disabled', false);
        }
      } else {
        qty = qty <= min ? min : qty -= 1;
        if (qty == min) {
          $this.attr('disabled', true);
        }
      }
      $input.val(qty).trigger('change');
    });
    return {
      init: init
    };
  }();
  var productGallery = function () {
    function init() {
      var $gallery = $('.product-gallery');
      var $slider = $gallery.find('.swiper');
      if (!$slider.length) {
        return;
      }
      var sliderOptions = {
        init: false,
        slidesPerView: 1,
        spaceBetween: 0,
        scrollbar: {
          el: $slider.find('.swiper-scrollbar').get(0),
          draggable: true
        },
        navigation: {
          nextEl: $slider.find('.swiper-button-next').get(0),
          prevEl: $slider.find('.swiper-button-prev').get(0)
        }
      };
      $slider.each(function () {
        var $this = $(this);
        var swiper = new Swiper($this.get(0), sliderOptions);
        if ($gallery.hasClass('product-gallery--addsamplepopup') || window.innerWidth <= 768) {
          swiper.init();
        }
      });
    }
    init();
    document.addEventListener('variantChange', function (e) {
      var $gallery = $('.product-gallery .swiper');
      // console.log($gallery);
      if ($gallery.length && productInfo.selectedVariant.featured_image) {
        $gallery.find('.swiper-slide').hide();
        $gallery.find('.swiper-slide[data-variant="' + productInfo.selectedVariant.id + '"]').show();
        $gallery.find('[data-similar-variants]').each(function () {
          var $this = $(this);
          // console.log($this);
          var variants = $this.data('similar-variants').toString().split(',');
          if (variants.indexOf(productInfo.selectedVariant.id.toString()) > -1) {
            // console.log('match');
            $this.show();
          }
        });
        var swiper = $gallery[0].swiper;
        if (swiper) {
          swiper.update();
          var $slides = $gallery.find('.swiper-slide:visible');
          $slides.each(function (i) {
            var $slide = $(this);
            if ($slide.data('variant') == productInfo.selectedVariant.id) {
              swiper.slideTo(i, 0);
            }
          });
        }
      }
    });
    return {
      init: init
    };
  }();
  var StickyATC = function () {
    var $section = $('.sticky-atc');
    var $section_cta = $section.find('.jst-product__cta');
    if (!$section.length) {
      return;
    }
    function update(product) {
      var $title = $section.find('.js-product__name');
      var $price = $section.find('.js-product__price');
      var $variant = $section.find('.js-product__variant');
      var $image = $section.find('.js-product__image');
      var $cost_per_sqft = $section.find('.js-product__cost-per-sqft');
      $section_cta.attr('disabled', !product.available).text(product.available ? 'Add to Cart' : 'Out of Stock');
      $price.text(Shopify.formatMoney(product.price, price_format).replace('$', window.currencySymbol + ' '));
      var pname = product.name.split(' -');
      $title.text(pname[0]);
      $variant.text(pname[1]);

      // console.log(product);

      if ($image.length && product.featured_image) {
        $image.attr('src', product.featured_image.src).attr('srcset', product.featured_image.src);
      }
    }
    var observer = new IntersectionObserver(function (entries) {
      var _this = entries[0];
      var position = _this.boundingClientRect.top;
      if (!_this.isIntersecting && position < 0) {
        $section.addClass('active');
      } else {
        $section.removeClass('active');
      }
    });
    var observer2 = new IntersectionObserver(function (entries) {
      var _this = entries[0];
      var position = _this.boundingClientRect.top;
      if (_this.isIntersecting) {
        $section.removeClass('active');
      } else {
        $section.addClass('active');
      }
    });
    observer.observe($("#addtocart").get(0));
    observer2.observe($("#shopify-section-footer-redesign").get(0));
    return {
      update: update
    };
  }();
  var JsTabs = function () {
    $('body').on('click', '.js-tabs__controller .btn', function () {
      var $this = $(this);
      var id = $this.data('id');
      $this.addClass('active').siblings().removeClass('active');
      $this.closest('.js-tabs').find('.js-tabs__content').removeClass('active').filter('[data-id="' + id + '"]').addClass('active');
    });
  }();
  var ProductOrderBy = function () {
    var sqft = 0;
    function updateSQFt() {
      var $coverage = $('.js-orderby__coverage');
      var $sqft_coverage = $('.js-orderby__sqft');
      var $box_qty = $('.js-qty__input');
      var $box_count = $('.js-orderby__boxcount');
      if (sqft > 0) {
        $box_count.text($box_qty.val());
        $sqft_coverage.text(parseFloat(sqft * $box_qty.val()).toFixed(2));
        $coverage.show();
      } else {
        $coverage.hide();
      }
    }
    ;
    function updateQuantity() {
      var $box_qty = $('input[name="quantity"]');
      var $box_count = $('.js-orderby__boxcount');
      var area = $('.js-orderby__boxarea').val();
      var bySFT = $('.product-orderby__content').hasClass('active') ? true : false;
      var add8Percent = $('.js-orderby__extra-coverage').is(':checked');
      if (bySFT && area > 0) {
        console.log(add8Percent);
        if (add8Percent) {
          area = area * 1.08;
        }
        var newQuantity = Math.ceil(area / sqft);
        $box_count.text(newQuantity);
        $box_qty.val(newQuantity).trigger('change');
      }
    }
    $('body').on('change', 'input[name="quantity"]', function () {
      updateSQFt();
    });
    $('body').on('change', '.js-orderby__boxarea', function () {
      updateQuantity();
    });
    $('body').on('change', '.js-orderby__extra-coverage', function () {
      updateQuantity();
    });
    $('body').on('click', '.js-orderby__controller .btn', function () {
      var $this = $(this);
      $this.addClass('active').siblings().removeClass('active');
      updateQuantity();
    });
    function setCoverageArea() {
      var $sqft_coverage = $('.js-orderby__sqft');
      var sqft_areas = $sqft_coverage.data('areas');

      // console.log(sqft_areas);

      productInfo.selectedVariant.options.forEach(function (option) {
        // console.log(option);
        if (sqft_areas.hasOwnProperty(option)) {
          // console.log(sqft_areas[option]);
          sqft = sqft_areas[option];
          return false;
        } else if (option == '7"' && sqft_areas.hasOwnProperty("7&quote")) {
          sqft = sqft_areas['7&quote'];
          return false;
        }
      });
      updateSQFt();
    }
    function initBoxes() {
      var is_box = productInfo.selectedVariant.options.indexOf('Box') > -1;
      $('.js-orderby').toggleClass('hidden', !is_box);
      $('.js-orderby__coverage').toggleClass('hidden', !is_box);
      if (is_box) {
        setCoverageArea();
      }
    }
    document.addEventListener('variantChange', function (e) {
      initBoxes();
    }, false);
  }();
  var displayMSRP = function () {
    var $msrp = $('.js-msrp');
    if (!$msrp.length) {
      return;
    }
    function updateMSRP() {
      if (productInfo.selectedVariant.hasOwnProperty('msrp')) {
        var msrp = productInfo.selectedVariant.msrp;
        // console.log(msrp );
        $msrp.addClass('active').find('.js-msrp__price').text(Shopify.formatMoney(msrp, price_format).replace('$', window.currencySymbol + ' '));
      } else {
        $msrp.removeClass('active');
      }
    }
    document.addEventListener('variantChange', function (e) {
      updateMSRP();
    }, false);
  }();
  var productVariants = function () {
    var variantChange = new Event('variantChange');
    function handleNonExistent($form) {
      var variants = window.productInfo[$form.data('handle')];
      var $groups = $form.find('.js-product-form__group');
      var $firstSelect = $groups.eq(0).find('.js-product-form__select');
      var firstOption = $firstSelect.val();
      var replaceVariant = false;
      $.each(variants, function (i, variant) {
        if (variant.option1 == firstOption) {
          replaceVariant = variant;
          // console.log(variant);
          if (variant.available) {
            return false;
          }
        }
      });
      if (replaceVariant) {
        var index = 0;
        $groups.each(function () {
          index++;
          var optionSelector = 'option' + index;
          $(this).find('input[value="' + replaceVariant[optionSelector] + '"]').trigger('click');
        });
      }
    }
    function selectVariant($form) {
      var variants = window.productInfo[$form.data('handle')];
      var $atc = $form.find('[type="submit"]');
      var atcText = $atc.data('text');
      var $groups = $form.find('.js-product-form__group');
      var $mainSelect = $form.find('.js-product-form__main-select');
      var options = [];
      $groups.each(function () {
        var $this = $(this);
        var val = $this.find('.js-product-form__select').val();
        options.push(val);
        $this.find('.js-product-form__selected-option').text(val);
      });
      var selectedVariant = false;
      $.each(variants, function (i, variant) {
        if (variant.option1 == options[0] && variant.option2 == options[1] && variant.option3 == options[2]) {
          selectedVariant = variant;
          return false;
        }
      });
      if (selectedVariant) {
        productInfo.selectedVariant = selectedVariant;
        $mainSelect.val(selectedVariant.id);
        document.dispatchEvent(variantChange);
        if ($form.hasClass('js-product-form--main')) {
          handle = $form.data('handle');
          window.history.replaceState(null, null, "/products/".concat(handle, "?variant=") + selectedVariant.id);
        }
        if (selectedVariant.available) {
          $atc.attr('disabled', false);
          $atc.text(atcText);
        } else {
          $atc.attr('disabled', true);
          $atc.text('Sold Out');
        }

        //do other theme specific things after a variant is selected
        //change image slide, update price etc...
        //selectedVariant is a object including all of its information that you may need

        var $parent = $form.closest('.js-product-container');
        var $price = $parent.find('.js-product__price');
        $price.text(Shopify.formatMoney(selectedVariant.price, price_format).replace('$', window.currencySymbol + ' '));
        if ($form.hasClass('js-product-form--main')) {
          StickyATC.update(selectedVariant);
        }
        if (selectedVariant.options.indexOf('Box') > -1) {}
      } else {
        handleNonExistent($form);
      }
    }
    function updateOptionsInSelector(selectorIndex, $form, allOptionsMap, inStockOptionsMap) {
      var key, $select;
      switch (selectorIndex) {
        case 0:
          key = 'root';
          $select = $form.find('.js-product-form__group:eq(0) .js-product-form__select');
          break;
        case 1:
          key = $form.find('.js-product-form__group:eq(0) .js-product-form__select').val();
          $select = $form.find('.js-product-form__group:eq(1) .js-product-form__select');
          break;
        case 2:
          key = $form.find('.js-product-form__group:eq(0) .js-product-form__select').val();
          key += ' / ' + $form.find('.js-product-form__group:eq(1) .js-product-form__select').val();
          $select = $form.find('.js-product-form__group:eq(2) .js-product-form__select');
      }
      var availableOptions = allOptionsMap[key];
      var inStockOption = inStockOptionsMap[key];
      $select.find('option').each(function (i, option) {
        var $this = $(this);
        var value = $this.val();
        var $radio = $this.closest('.js-product-form__group').find('input[type="radio"][value="' + encodeURIComponent(value) + '"]');
        if (availableOptions && availableOptions.includes(value)) {
          $this.attr('disabled', false);
          $radio.attr('disabled', false);
          if (inStockOption && inStockOption.includes(value)) {
            $this.text($this.val());
            $this.removeClass('oos');
            $radio.removeClass('oos');
          } else {
            $this.text($this.val() + ' (Soldout)');
            $this.addClass('oos');
            $radio.addClass('oos');
          }
        } else {
          $this.text($this.val());
          $this.attr('disabled', true);
          $radio.attr('disabled', true);
        }
      });
    }
    function linkOptionSelectors($form) {
      var variants = window.productInfo[$form.data('handle')];
      var Shopify = Shopify || {};
      Shopify.arrayIncludes = function (e, t) {
        for (var n = 0; n < e.length; n++) if (e[n] == t) return !0;
        return !1;
      }, Shopify.uniq = function (e) {
        for (var t = [], n = 0; n < e.length; n++) Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
        return t;
      };
      var allOptionsMap = {};
      var inStockOptionsMap = {};
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var key;
        if (variant) {
          allOptionsMap.root = allOptionsMap.root || [];
          allOptionsMap.root.push(variant.option1);
          allOptionsMap.root = Shopify.uniq(allOptionsMap.root);
          if (variant.options.length > 1) {
            key = variant.option1;
            allOptionsMap[key] = allOptionsMap[key] || [];
            allOptionsMap[key].push(variant.option2);
            allOptionsMap[key] = Shopify.uniq(allOptionsMap[key]);
          }
          if (variant.options.length === 3) {
            key = variant.option1 + ' / ' + variant.option2;
            allOptionsMap[key] = allOptionsMap[key] || [];
            allOptionsMap[key].push(variant.option3);
            allOptionsMap[key] = Shopify.uniq(allOptionsMap[key]);
          }
        }
        if (variant.available) {
          inStockOptionsMap.root = inStockOptionsMap.root || [];
          inStockOptionsMap.root.push(variant.option1);
          inStockOptionsMap.root = Shopify.uniq(inStockOptionsMap.root);
          if (variant.options.length > 1) {
            key = variant.option1;
            inStockOptionsMap[key] = inStockOptionsMap[key] || [];
            inStockOptionsMap[key].push(variant.option2);
            inStockOptionsMap[key] = Shopify.uniq(inStockOptionsMap[key]);
          }
          if (variant.options.length === 3) {
            key = variant.option1 + ' / ' + variant.option2;
            inStockOptionsMap[key] = inStockOptionsMap[key] || [];
            inStockOptionsMap[key].push(variant.option3);
            inStockOptionsMap[key] = Shopify.uniq(inStockOptionsMap[key]);
          }
        }
      }
      updateOptionsInSelector(0, $form, allOptionsMap, inStockOptionsMap);
      if (variants[0].options.length > 1) updateOptionsInSelector(1, $form, allOptionsMap, inStockOptionsMap);
      if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);
      $form.find('.js-product-form__group:eq(0) .js-product-form__select').change(function () {
        updateOptionsInSelector(1, $form, allOptionsMap, inStockOptionsMap);
        if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);
        return true;
      });
      $form.find('.js-product-form__group:eq(1) .js-product-form__select').change(function () {
        if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);
        return true;
      });
    }
    function init($form) {
      function handleSelectChange($select) {
        var $form = $select.closest('form');
        linkOptionSelectors($form);
        selectVariant($form);
      }
      $form.on('change', 'select', function () {
        handleSelectChange($(this));
      });
      $form.on('change', '.js-product-form__button', function () {
        var $this = $(this);
        var $select = $this.closest('.js-product-form__group').find('.js-product-form__select');
        $select.val($this.val());
        handleSelectChange($select);
      });
      var $firstSelect = $form.find('.js-product-form__select').eq(0);
      $firstSelect.trigger('change');
    }
    var $forms = $('.js-product-form');
    $forms.each(function () {
      var $form = $(this);
      init($form);
    });
    return {
      init: init
    };
  }();
  var AddSample = function () {
    function initAddSample() {
      var $form = $('.js-product-form--addsample');
      var $product_type = $('.pdp-atc__group--type');
      LazyLoading.refresh();
      productVariants.init($form);
      $product_type.hide();
      productGallery.init();
      $form.find('.js-product-form__button[value="Cut Sample"]').attr('checked', true).trigger('change');
    }
    $('body').on('click', '.js-addsample-close', function () {
      $('.product-addsamplepopup').removeClass('active');
    });
    $('body').on('click', '.js-addsample', function () {
      var $this = $(this);
      var url = $this.data('url');
      var $lightbox = $('.product-addsamplepopup');
      var $lightbox_content = $('.product-addsamplepopup .pdm-lightbox__content');
      var variant_id = $this.closest('.product-card').find('.product-swatch.active').data('variantId');
      $.ajax({
        url: window.Shopify.routes.root + url + '?view=addsample&variant=' + variant_id,
        type: "GET",
        success: function success(res) {
          // console.log(res);
          $lightbox_content.html($(res).find('#product-addsamplepopup').html());
          $lightbox.addClass('active');
          initAddSample();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    });
  }();
  var GalleryPopup = function () {
    var $section = $('.js-gallery-popup');
    if (!$section.length) {
      return;
    }
    function initPopup() {
      var $slider = $('.gallerypopup .swiper');
      if (!$slider.length) {
        return;
      }
      var sliderOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        scrollbar: {
          el: $slider.find('.swiper-scrollbar').get(0),
          draggable: true
        },
        navigation: {
          nextEl: $slider.find('.swiper-button-next').get(0),
          prevEl: $slider.find('.swiper-button-prev').get(0)
        }
      };
      var swiper = new Swiper($slider.get(0), sliderOptions);
    }
    $('body').on('click', '.js-gallery-popup', function () {
      var $this = $(this);
      var $lightbox = $('.gallerypopup');
      var $lightbox_content = $lightbox.find('.pdm-lightbox__content');
      var url = $this.data('url');
      $.ajax({
        url: url + '?view=gallerypopup',
        type: "GET",
        success: function success(res) {
          // console.log(res);
          $lightbox_content.html($(res).find('#gallery-product-popup').html());
          initPopup();
          $lightbox.addClass('active');
        },
        error: function error(res) {
          console.log(res);
        }
      });
    });
  }();
  var siteOverlay = function () {
    var $overlay = $('.js-site-overlay');
    function closeUtils() {
      shopCart.close();
      if (predictiveSearch != undefined) {
        predictiveSearch.close();
      }
      if (Header != undefined) {
        Header.closeMenus();
      }
      $('body').removeClass('overlay-open--under-header');
    }
    function close() {
      $overlay.removeClass('active');
      $('body').removeClass('overlay-open');
      closeUtils();
    }
    function open() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$overHeader = _ref.overHeader,
        overHeader = _ref$overHeader === void 0 ? true : _ref$overHeader;
      closeUtils();
      $('body').addClass('overlay-open');
      if (overHeader == false) {
        $('body').addClass('overlay-open--under-header');
      }
      $overlay.addClass('active');
    }
    $overlay.click(function () {
      close();
    });
    return {
      open: open,
      close: close
    };
  }();
  var shopCart = function (updates) {
    var $body = $('body');
    var $popcart = $('.pop-cart');
    function open() {
      if (!$body.hasClass('template-cart')) {
        siteOverlay.open();
        $body.addClass('cart-open');
        $popcart.addClass('active');
      }
    }
    function close() {
      $body.removeClass('cart-open');
      $popcart.removeClass('active');
    }
    function refresh() {
      $.ajax({
        url: '/?sections=pop-cart',
        dataType: 'json',
        type: "get",
        success: function success(res) {
          // console.log(res);
          var newCart = $(res['pop-cart']).find('form').html();
          $popcart.find('form').html(newCart);
          open();
        },
        error: function error(res) {
          console.log(res);
          open();
        }
      });
    }
    function remove(updates) {
      // console.log(updates);
      $.ajax({
        url: window.Shopify.routes.root + 'cart/update.js',
        type: "post",
        data: {
          updates: updates
        },
        success: function success(res) {
          refresh();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    function update(updates) {
      // console.log(updates);
      $.ajax({
        url: window.Shopify.routes.root + 'cart/change.js',
        type: "post",
        data: updates,
        success: function success(res) {
          // console.log('cart updated');
          refresh();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    function add($form) {
      $.ajax({
        url: window.Shopify.routes.root + 'cart/add.js',
        type: "post",
        data: $form.serialize(),
        success: function success(res) {
          refresh();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    return {
      add: add,
      open: open,
      close: close,
      refresh: refresh,
      remove: remove,
      update: update
    };
  }();
  var Cart = function () {
    var $cart = $('.pop-cart');
    var $cartIcon = $('.js-cart-drawer-trigger');
    $('body').on('click', '.js-cart-drawer-close', function () {
      siteOverlay.close();
      shopCart.close();
    });
    $cartIcon.click(function (e) {
      e.preventDefault();
      shopCart.open();
    });
    $('body').on('click', '.js-remove-cart-item', function (e) {
      e.preventDefault();
      var $card = $(this).closest('.cart-card');
      var id = parseInt($card.data('id'));
      var item = {};
      item[id] = 0;
      shopCart.remove(item);
    });
    $('body').on('change', '[name="updates[]"]', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $card = $this.closest('.cart-card');
      var id = parseInt($card.data('id'));
      var item = {};
      item.id = id;
      item.quantity = $this.val();
      shopCart.update(item);
    });
    var openCartParam = urlParams.get('cart');
    if (openCartParam == 'open') {
      console.log('open cart');
      shopCart.open();
    }
  }();
  var AddToCartForm = function () {
    function updateSubtotal() {
      var total_qty = parseInt($('#quantity').val());
      var $prod_subtotal = $('.js-product__subtotal');
      var subtotal = Shopify.formatMoney(productInfo.selectedVariant.price * total_qty, price_format).replace('$', window.currencySymbol + ' ');
      $prod_subtotal.text(subtotal);
    }
    function updateCostPerOption() {
      var $product_type = $('input[name="Type"]:checked');
      var $product_model = $('input[name="Model"]:checked');
      $('.js-product__type').text($product_type.val());
      $('.js-product__cost-per-sqft').text($product_model.data('cost-per-sqft'));
    }
    $('#quantity').change(function () {
      updateSubtotal();
    });
    document.addEventListener('variantChange', function (e) {
      updateSubtotal();
      updateCostPerOption();
    }, false);
    $('body').on('submit', 'form[action="/cart/add"]', function (e) {
      e.preventDefault();
      shopCart.add($(this));
    });
  }();
  var Header = function () {
    var $body = $('body');
    var $header = $('.gheader');
    var $nav = $header.find('.gheader__mnav');
    var $announcement = $('.announcement-banner');
    var header_height = $header.innerHeight();
    if (window.innerWidth < 960) {
      if ($announcement.length) {
        header_height -= $announcement.innerHeight();
      }
      $nav.css({
        marginTop: header_height
      });
    }
    var BurgerMenu = function () {
      var $burgerMenu = $header.find('.gheader__burger');
      function activate() {
        $burgerMenu.addClass('active').attr('title', 'Close');
        $nav.addClass('active');
        $body.addClass('no-scroll');
        var styles = {
          position: 'fixed'
        };
        $header.css(styles);
        $body.css({
          marginTop: $header.innerHeight()
        });
      }
      function reset() {
        $burgerMenu.removeClass('active').attr('title', 'Menu');
        $nav.removeClass('active').find('.active').removeClass('active');
        $body.removeClass('no-scroll');
        var styles = {
          position: 'sticky'
        };

        // $header.css(styles);
        $body.css({
          marginTop: 0
        });
      }
      $burgerMenu.click(function () {
        var $this = $(this);
        if ($this.hasClass('active')) {
          reset();
        } else {
          activate();
        }
      });
      return {
        close: reset,
        open: activate
      };
    }();
    var CheckIfScrolled = function () {
      if (!$header.hasClass('sticky')) {
        return;
      }

      /* kl - removed sticky header */
      // if (window.scrollY) {
      //     $header.addClass('custom-sticky');
      // }

      // $(window).on('scroll', function () {

      //     // console.log(window.scrollY);

      //     if (window.scrollY && window.scrollY > 50) {
      //         $header.addClass('custom-sticky');

      //     } else{
      //         $header.removeClass('custom-sticky');
      //     }
      // });
      /* /kl - removed sticky header */
    }();
    window.addEventListener('resize', function () {
      // $header.css({ position: 'sticky' });

      BurgerMenu.close();
      var styles = {
        marginTop: window.innerWidth < 960 ? header_height : 0
      };
      $nav.css(styles);
    });

    //mobile menu function
    var $mobDropdowns = $('.gheader__mnav .parent-link.haslinks > a');
    $mobDropdowns.click(function (e) {
      e.preventDefault();
      var $this = $(this);
      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $this.next().slideUp();
      } else {
        $mobDropdowns.removeClass('active');
        $mobDropdowns.next().slideUp();
        $this.toggleClass('active');
        $this.next().slideDown();
      }
    });

    //mega menu function
    //on click of desktop nav, check if its the current mega menu active and turn it off
    // if its not the current one turn off all mega menus, find the right one using the data attribute and activate it
    var $megamenuTrigger = $('.gheader__nav [data-menu]');
    var $megamenus = $('.mega-menu');
    function closeMenus() {
      $megamenus.removeClass('active');
      $megamenuTrigger.removeClass('active');
    }
    $megamenuTrigger.click(function (e) {
      e.preventDefault();
      var $this = $(this);
      var menu = $this.data('menu');
      var $menu = $megamenus.filter('[data-menu="' + menu + '"]');

      /* kl - removed sticky header */
      // if ($('body.template-index').length && window.scrollY == 0) {
      //     $('.gheader').toggleClass('custom-sticky', !$this.hasClass('active'));
      // }
      /* /kl - removed sticky header */

      if ($this.hasClass('active')) {
        // console.log('is active');
        siteOverlay.close();
        closeMenus();
      } else {
        siteOverlay.open({
          overHeader: false
        });
        // console.log('opening new menu');
        $this.addClass('active');
        $menu.addClass('active');
      }
    });
    return {
      closeMenus: closeMenus
    };
  }();
  var collectionBreadcrumbs = function () {
    var $select = $('.mob-hero-nav select');
    if (!$select.length) {
      return;
    }
    $select.change(function () {
      var url = $(this).val();
      window.location = url;
    });
  }();
  var gallerySearch = function () {
    var $search = $('.col-search-filter input[type="search"]');
    if (!$search.length) {
      return;
    }
    var $cards = $('.gallery-card');
    $search.keyup(function () {
      var $this = $(this);
      var searchTerm = $this.val();
      if ($this.val().trim() !== '') {
        $cards.addClass('searching');
        $cards.each(function () {
          var $this = $(this);
          var cardId = $this.attr('id');
          if (cardId == undefined) {
            $this.hide();
            return;
          }
          console.log(cardId);
          if (cardId.includes(searchTerm)) {
            $this.show();
          } else {
            $this.hide();
          }
        });
      } else {
        $cards.removeClass('searching');
        $cards.show();
      }
    });
  }();
  var collectionFacets = function () {
    var $ajaxWrap = $('#js-collection');
    if (!$ajaxWrap.length) {
      return;
    }
    var base_url = location.origin + location.pathname;
    var urls = [];
    var responses = [];
    urls.push(base_url);
    responses.push($('#js-collection').html());
    function filterCollection(url) {
      var currentPath = window.location.pathname.split("?")[0];
      var finalUrl;
      if (url.toString().includes(currentPath)) {
        finalUrl = window.location.origin + url;
      } else {
        finalUrl = window.location.origin + currentPath + url;
      }
      if (urls.indexOf(finalUrl) > -1) {
        $ajaxWrap.html(responses[urls.indexOf(finalUrl)]);
        LazyLoading.refresh();
      } else {
        $.ajax({
          url: finalUrl,
          type: "GET",
          beforeSend: function beforeSend() {
            $ajaxWrap.find('.collection-grid').addClass('loading');
          },
          success: function success(res) {
            var ajaxHTML = $(res).find('#js-collection').html();
            $ajaxWrap.html(ajaxHTML);
            urls.push(finalUrl);
            responses.push(ajaxHTML);
            LazyLoading.update();
            StickToHeader.refresh();
            productCard.init();
          },
          error: function error(res) {
            console.log(res);
          }
        });
      }
      window.history.replaceState(null, null, finalUrl);
    }
    $('body').on('submit', 'form.col-facets', function (e) {
      e.preventDefault();
      var $this = $(this);
      var url = base_url;
      if ($this.serialize()) {
        url = '?' + $this.serialize();
      }
      filterCollection(url);
    });
    $('body').on('click', '.remove-filter', function () {
      var $this = $(this);
      filterCollection($this.data('remove'));
    });
    $('body').on('change', 'form.col-facets', function () {
      $('.col-facets__submit').click();
    });
    $('body').on('change', '.facet-filters__sort', function () {
      $('[name="sort_by"]').val($(this).val());
      $('.col-facets__submit').click();
    });
    $('body').on('click', '.filter legend', function () {
      var $is_active = $(this).closest('.filter').hasClass('active');
      $('.filter').removeClass('active');
      if (!$is_active) {
        $(this).closest('.filter').addClass('active');
      }
    });
    $('body').on('click', '.show-filters', function () {
      $('form.col-facets').toggleClass('active');
    });
  }();
  var predictiveSearch = function () {
    var $search = $('.js-site-search');
    var $searchForm = $('.js-site-search__form');
    var $searchInput = $('.js-site-search__input');
    var $searchIcon = $('.js-site-search__open');
    var $searchClose = $('.js-site-search__close');
    var $searchResults = $('.js-site-search__results');
    function close() {
      $search.fadeOut(function () {
        $searchInput.val('');
        $searchResults.removeClass('active');
      });
    }
    $searchClose.click(function () {
      close();
      siteOverlay.close();
    });
    $searchIcon.click(function () {
      siteOverlay.open();
      $search.fadeIn();
      $searchInput.focus();
    });
    function ajaxSearch(terms) {
      $.ajax({
        url: '/search/suggest',
        type: "GET",
        data: {
          q: terms,
          section_id: 'site-search',
          // resources[type]: 'query,product,collection,page,article',
          'resources[type]': 'query,product,page,article'
        },
        success: function success(res) {
          $searchResults.html($(res).find('#predictive-search-results').html());
          $searchResults.addClass('active');
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    $searchInput.keyup(function (e) {
      if (e.keyCode == 13) {
        return;
      }
      ajaxSearch($searchInput.val());
    });
    $searchForm.submit(function (e) {
      e.preventDefault();
      ajaxSearch($searchInput.val());
    });
    $('body').on('click', '.js-site-search__suggestions button', function () {
      var val = $(this).text();
      $searchInput.val(val);
      ajaxSearch(val);
    });
    return {
      close: close
    };
  }();

  /**
   * TODO: Create a separate JS file for the following functions
   * - loginPage
   * - addressPage
   * maybe customer.js
   */
  var loginPage = function () {
    var $loginToggle = $('.login-toggle');
    if (!$loginToggle.length) {
      return;
    }
    if (window.location.href.indexOf('recover') > -1) {
      $('.reset-tab').show();
      $('.login-tab').hide();
    }
    $loginToggle.click(function () {
      $('.reset-tab').toggle();
      $('.login-tab').toggle();
    });
  }();
  var addressPage = function () {
    $('button.add-address').click(function () {
      $('.add-address-lightbox').addClass('active');
    });
    $('.edit-address').click(function () {
      var target = $(this).data('target');
      $('#lightbox-' + target).addClass('active');
    });
  }();
  var gladlyTrigger = function () {
    var $trigger = $('[href="#trigger-gladly"]');
    if (!$trigger.length) {
      return;
    }
    $trigger.click(function (e) {
      e.preventDefault();
      Gladly.show();
      // window._gladly = window._gladly || [];
      // window._gladly.push(['showChat']);
    });
  }();

  /**
   * SECTION JS GOES HERE
   */

  var productCard = function () {
    function init() {
      $('body').on('click', '.product-card__swatches button', function () {
        var $this = $(this);
        if ($this.hasClass('disabled')) {
          return false;
        }
        var price = $this.data('price');
        var image = $this.data('image');
        var hover_image = $this.data('imageHover');
        var $card = $this.parents('.product-card');
        var $swatches = $card.find('.product-card__swatches button');
        var $image = $card.find('.product-card__image img');
        var $hover_img = $card.find('.js-product-card-hover-image');
        var $cost_per_sqft = $card.find('.product-card__cost-per-sqft');
        $card.find('.js-product__price').text(price);
        $card.find('.js-product__variant').text($this.attr('title'));
        $cost_per_sqft.text($this.data('cost-per-sqft'));
        $swatches.removeClass('active');
        $this.addClass('active');

        // $image.parent().addClass('variant-active');
        $image.attr('src', image).attr('srcset', image);
        if (hover_image.length) {
          $hover_img.attr('data-bg', hover_image);
          // console.log($hover_img.data('bg'));
          $hover_img.removeClass('entered').addClass('lazy').removeClass('loaded');
          $hover_img[0].removeAttribute('data-ll-status');
          LazyLoading.refresh();
        }
      });
      var variantModel = urlParams.get('filter.v.option.model');
      $('.product-card').each(function () {
        var $this = $(this);
        if (variantModel) {
          $this.find('.product-card__swatches button').filter('[value="' + variantModel + '"]').eq(0).trigger('click');
        } else {
          $this.find('.product-card__swatches button').eq(0).trigger('click');
        }
      });
    }
    init();
    return {
      init: init
    };
  }();
  var featProductsSlider = function () {
    var $sections = $('.ft-prod-col');
    if (!$sections.length) {
      return;
    }
    $sections.each(function () {
      var $section = $(this);
      var $slider = $section.find('.ft-prod-col__slider');
      var swiper = new Swiper($slider.get(0), {
        slidesPerView: 1.2,
        spaceBetween: 16,
        scrollbar: {
          el: $section.find('.swiper-controls.mob-only .swiper-scrollbar').get(0),
          draggable: true
        },
        navigation: {
          nextEl: $section.find('.swiper-controls.mob-only .swiper-button-next').get(0),
          prevEl: $section.find('.swiper-controls.mob-only .swiper-button-prev').get(0)
        },
        breakpoints: {
          720: {
            slidesPerView: 2,
            scrollbar: {
              el: $section.find('.swiper-controls.desk-only .swiper-scrollbar').get(0),
              draggable: true
            },
            navigation: {
              nextEl: $section.find('.swiper-controls.desk-only .swiper-button-next').get(0),
              prevEl: $section.find('.swiper-controls.desk-only .swiper-button-prev').get(0)
            }
          }
        }
      });
      if (swiper.enabled) {
        $slider.parent().find('.swiper-controls').show();
      }
    });
  }();
  var FeaturedProducts = function () {
    var $section = $('.featprods');
    if (!$section.length) {
      return;
    }
    var $slider = $section.find('.swiper');
    $slider.each(function () {
      var $this = $(this);
      var swiper = new Swiper($this.get(0), {
        slidesPerView: 1.2,
        spaceBetween: 16,
        scrollbar: {
          el: $slider.find('.swiper-scrollbar').get(0),
          draggable: true
        },
        navigation: {
          nextEl: $slider.find('.swiper-button-next').get(0),
          prevEl: $slider.find('.swiper-button-prev').get(0)
        },
        breakpoints: {
          720: {
            slidesPerView: 2
          },
          960: {
            slidesPerView: 3
          }
        }
      });
      if (window.innerWidth > 960 && swiper.slides.length < 4) {
        $this.find('.swiper-controls').hide();
      }
    });
  }();
  var SelectMenuRedirects = function () {
    var $section = $('.js-select-redirects');
    if (!$section.length) {
      return;
    }
    $section.change(function () {
      console.log($(this).val());
      window.location.href = $(this).val();
    });
  }();
  var blogFilters = function () {
    var $filters = $('.tag-filters input');
    if (!$filters.length) {
      return;
    }
    $filters.change(function () {
      var filters = '';
      $filters.filter(':checked').each(function () {
        filters += $(this).val() + '+';
      });
      filters = filters.slice(0, -1);
      var redirect = $('#blog-tag-select').val();
      if (filters.length) {
        if (redirect.includes('tagged')) {
          redirect = redirect + '+' + filters;
        } else {
          redirect = redirect + '/tagged/' + filters;
        }
      }
      window.location.href = redirect;
    });
  }();
  var recentBlogPosts = function () {
    var $slider = $('.recent-blog-wrapper__slider');
    var $section = $('.recent-posts');
    if (!$slider.length) {
      return;
    }
    $slider.each(function () {
      var $this = $(this);
      var swiper = new Swiper($this.get(0), {
        slidesPerView: 1.1,
        spaceBetween: 32,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
        navigation: {
          nextEl: $section.find('.swiper-button-next').get(0),
          prevEl: $section.find('.swiper-button-prev').get(0)
        },
        breakpoints: {
          960: {
            slidesPerView: 2
          }
        }
      });
    });
  }();
  var customerStorySlider = function () {
    var $slider = $('.cstories__loop');
    if (!$slider.length) {
      return;
    }
    $slider.each(function () {
      var $this = $(this);
      var swiper = new Swiper($this.get(0), {
        slidesPerView: 1.4,
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: $slider.find('.swiper-button-next').get(0),
          prevEl: $slider.find('.swiper-button-prev').get(0)
        },
        breakpoints: {
          960: {
            slidesPerView: 2.8
          },
          1400: {
            slidesPerView: 3.25
          },
          1600: {
            slidesPerView: 4
          }
        }
      });
    });
  }();
  var testimonials = function () {
    var $slider = $('.testimonials-slider');
    var $section = $('.testimonials-block');
    if (!$slider.length) {
      return;
    }
    $slider.each(function () {
      var $this = $(this);
      var swiper = new Swiper($this.get(0), {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        scrollbar: {
          el: $section.find('.swiper-scrollbar').get(0),
          draggable: true
        },
        navigation: {
          nextEl: $section.find('.swiper-button-next').get(0),
          prevEl: $section.find('.swiper-button-prev').get(0)
        }
      });
    });
  }();

  // var FeaturedPostSlider = (function () {
  //     var $section = $('.featured-posts-slider');
  //     if (!$section.length) { return; }
  //     var $slider = $section.find('.swiper');
  //     $slider.each(function () {

  //         var $this = $(this);
  //         var swiper = new Swiper($this.get(0), {
  //             slidesPerView: 1,
  //             spaceBetween: 16,
  //             autoHeight: true,
  //             loop: true,
  //             fadeEffect: {
  //                 crossFade: true
  //             },
  //             effect: 'fade',
  //             navigation: {
  //                 nextEl: $section.find('.swiper-button-next').get(0),
  //                 prevEl: $section.find('.swiper-button-prev').get(0),
  //             }
  //         });
  //     });

  // }());

  var imageCard = function () {
    var $slider = $('.image-card-slider');
    var $section = $('.image-card-block');
    if (!$slider.length) {
      return;
    }
    $slider.each(function () {
      var $this = $(this);
      var swiper = new Swiper($this.get(0), {
        slidesPerView: 1,
        spaceBetween: 0,
        scrollbar: {
          el: $section.find('.swiper-scrollbar').get(0),
          draggable: true
        },
        navigation: {
          nextEl: $section.find('.swiper-button-next').get(0),
          prevEl: $section.find('.swiper-button-prev').get(0)
        }
      });
    });
  }();
});
var PreOrderNotification = function () {
  function decode(input) {
    var txt = document.createElement("textarea");
    txt.innerHTML = input;
    return txt.value;
  }
  document.addEventListener('variantChange', function (e) {
    var $section = $('.js-preorder-notification');
    if (!$section.length) {
      return;
    }
    var $po_message = productInfo.selectedVariant.preorder_message || false;
    if ($po_message) {
      var message = decode($po_message);
      $section.find('.js-preorder-notification__message').html(message);
      $section.removeClass('hidden');
    } else {
      $section.addClass('hidden');
    }
  }, false);
  var ModelCompare = function () {
    var $section = $('.model-compare');
    if (!$section.length) {
      return;
    }
    var $specCard = $section.find('.js-prodspec');
    $specCard.find('.js-prodspec__trigger').click(function () {
      $(this).closest('.js-prodspec').toggleClass('active');
    });
    $specCard.find('.js-prodspec__close').click(function () {
      $(this).closest('.js-prodspec').removeClass('active');
    });
    var swiper = new Swiper($section.find('.swiper').get(0), {
      init: false,
      slidesPerView: 1,
      spaceBetween: 16,
      scrollbar: {
        el: $section.find('.swiper-scrollbar').get(0)
      },
      breakpoints: {
        720: {
          slidesPerView: 2
        }
      }
    });
    if (window.innerWidth < 960) {
      swiper.init();
    }
  }();
  var AccordionTimeline = function () {
    var $section = $('.content-timeline');
    if (!$section.length) {
      return;
    }
    function initAutoTimeline($this) {
      var interval = 7000;
      var $slides = $this.find('.swiper-slide');
      var active_slide = 0;
      var timeline;
      $slides.find('.js-accordion-timeline__content').first().addClass('active').show();
      function resetTimeline() {
        timeline = setInterval(function () {
          active_slide = active_slide + 1 >= $slides.length ? 0 : active_slide + 1;
          // console.log(active_slide);

          $slides.removeClass('active').find('.accordion-timeline').removeClass('active');
          $slides.find('.accordion-timeline__content').slideUp();
          $slides.eq(active_slide).addClass('active').find('.accordion-timeline').addClass('active').find('.accordion-timeline__content').slideDown();
        }, interval);
      }
      resetTimeline();
      $this.hover(function (e) {
        var e_type = e.type;
        var $e = $(e.currentTarget);
        if (e_type == 'mouseenter') {
          clearInterval(timeline);
        } else {
          resetTimeline();
        }
      });
      $slides.click(function () {
        active_slide = $slides.index($(this));

        /* TODO: Finish this function.
         * take the index of the clicked slide and set it as the active slide
         * */
        $slides.removeClass('active').find('.accordion-timeline').removeClass('active');
        $slides.find('.accordion-timeline__content').slideUp();
        $slides.eq(active_slide).addClass('active').find('.accordion-timeline').addClass('active').find('.accordion-timeline__content').slideDown();
      });
    }
    $section.each(function () {
      var $this = $(this);
      var $accordions = $this.find('.js-accordion-timeline');
      var $slider = $this.find('.swiper');
      var timeline_delay = 5000;
      $slider.each(function () {
        var _this = $(this);
        var swiper = new Swiper(_this.get(0), {
          init: false,
          slidesPerView: 1
        });
        if (window.innerWidth < 960) {
          swiper.init();
        } else {
          initAutoTimeline(_this);
        }
      });
    });
  }();
  var AnimatedHero = function () {
    var $section = $('.animated-hero');
    if (!$section.length) {
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    var $content_main = $section.find('.animated-hero__content--main');
    var $content_dup = $section.find('.animated-hero__content--dup');
    var $bg_image = $section.find('.animated-hero__bg img');
    var $clip = $section.find('.animated-hero__clip');
    var hero_height = $section.innerHeight() - 200;
    var header_height = $('.gheader').innerHeight();
    var window_width = window.innerWidth;
    var window_width_20 = window_width * 0.1;
    gsap.set($clip, {
      clipPath: 'inset(' + hero_height + 'px ' + (window_width_20 - 1) + 'px 0px ' + (window_width_20 + 1) + 'px)',
      opacity: 1
    });
    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: $section.get(0),
        start: 'top ' + header_height + 'px',
        end: 'bottom ' + header_height + 'px',
        scrub: true,
        pin: true
      }
    });
    tl.to($clip, {
      clipPath: 'inset(' + hero_height / 1.5 + 'px ' + (window_width_20 - 1) + 'px 0px ' + (window_width_20 + 1) + 'px)',
      duration: 4
    }, '1');
    tl.to($clip, {
      clipPath: 'inset(0px 0px 0px -1px)',
      duration: 4
    });
    tl.to($bg_image, {
      scale: 1.3,
      duration: 8
    }, '1');
  }();
  var ExpandingCards = function () {
    var $section = $('.expanding-cards');
    if (!$section.length) {
      return;
    }
    var $expcard = $section.find('.js-expcard');
    $expcard.find('.js-expcard__trigger').click(function () {
      $(this).closest('.js-expcard').toggleClass('active');
    });
    $expcard.find('.js-expcard__close').click(function () {
      $(this).closest('.js-expcard').removeClass('active');
    });
  }();
}();